import { Box, type BoxComponentProps, Flex, Progress, type ProgressProps, Text } from "@mantine/core";
import type { JSX } from "react";
import type { ChallengeCondition } from "@/sales-tools/challenges/api/getChallengesForEmployee";

type ChallengeTargetProps = BoxComponentProps & {
    target: ChallengeCondition;
    progress?: Partial<ProgressProps>;
};

export function ChallengeTarget({ target, progress, ...box }: ChallengeTargetProps): JSX.Element {
    const { goalType, currentValue, targetValue } = target;
    return (
        <Box {...box}>
            <Flex align="center">
                <Text data-testid="challenge-target-progression" fw={700} c="dark.0" size="xs">
                    {currentValue}/{targetValue}
                </Text>
                <Text data-testid="challenge-target-goal-type" ml="5px" c="dark.2" size="12px">
                    {goalType}
                </Text>
            </Flex>
            <Progress my="3xs" h="4px" color="success.6" value={(currentValue / targetValue) * 100} {...progress} />
        </Box>
    );
}
